import { Route } from '@angular/router';
import { LoginPageComponent } from '@app/auth/components/login-page/login-page.component';
import { ResetPasswordComponent } from '@app/auth/components/reset-password/reset-password.component';
import { AuthGuardService } from '@app/auth/services/auth-guard.service';
import { InitialRoutingComponent } from '@app/core/components/initial-routing/initial-routing.component';
import { RedirRoutingComponent } from '@app/core/components/redir-routing/redir-routing.component';
import { PortalInitialisedGuard } from '@app/portal/services/portal-initialised-guard.service';
import { UnsavedChangesService } from '@app/shared/services/unsaved-changes-service';
import { TranslationOverviewComponent } from '@app/translate/components/translation-overview/translation-overview.component';

export const BUSINESS_BASE_ROUTE: Route = {
  canActivate: [AuthGuardService, PortalInitialisedGuard],
  data: {
    baseRoute: true,
  },
  loadChildren: () =>
    import(/* webpackChunkName: "routes" */ '../business/system-admin-routing.module').then(
      (m) => m.SystemAdminRoutingModule
    ),
  path: '',
};

export const CATCH_ALL: Route = {
  path: '**',
  component: InitialRoutingComponent,
  canActivate: [AuthGuardService, PortalInitialisedGuard],
};

export const FORGOT_PASSWORD: Route = {
  canActivate: [PortalInitialisedGuard],
  component: ResetPasswordComponent,
  data: {
    hidePortalContainer: true,
    name: 'forgot-password',
  },
  path: 'forgot-password',
};

export const INITIAL_ROUTE: Route = {
  component: InitialRoutingComponent,
  canActivate: [AuthGuardService, PortalInitialisedGuard],
  data: {
    name: 'initial-route',
  },
  path: '',
};

export const LOGIN: Route = {
  component: LoginPageComponent,
  data: {
    hidePortalContainer: true,
    name: 'login',
  },
  path: 'login',
};

export const REDIRECT_CATCH_ALL: Route = {
  path: 'redir',
  children: [
    {
      data: {
        // refs #78826 this instructs the auth-guard not to perform the `checkUserAgainstRoute`, otherwise it will block the route.
        baseRoute: true,
      },
      canActivate: [AuthGuardService, PortalInitialisedGuard],
      component: RedirRoutingComponent,
      path: '**',
    },
  ],
};

export const TRANSLATIONS: Route = {
  canActivate: [AuthGuardService, PortalInitialisedGuard],
  canDeactivate: [UnsavedChangesService],
  component: TranslationOverviewComponent,
  data: {
    name: 'translations',
  },
  path: 'translations',
};
